export var getBoundingClientRect = function getBoundingClientRect(node) {
  return node.getBoundingClientRect();
};